module.exports = __webpack_public_path__ + "static/media/chat.c4158b64.png";